export default __webpack_public_path__ + "f2bf634c8dedb42b73a16337471dc058.png";